import { render, staticRenderFns } from "./AdditionalsAutoSidebarMenu.vue?vue&type=template&id=4261e902&scoped=true&"
import script from "./AdditionalsAutoSidebarMenu.vue?vue&type=script&lang=js&"
export * from "./AdditionalsAutoSidebarMenu.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalsAutoSidebarMenu.vue?vue&type=style&index=0&id=4261e902&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4261e902",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4261e902')) {
      api.createRecord('4261e902', component.options)
    } else {
      api.reload('4261e902', component.options)
    }
    module.hot.accept("./AdditionalsAutoSidebarMenu.vue?vue&type=template&id=4261e902&scoped=true&", function () {
      api.rerender('4261e902', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Sidebar/SidebarComponents/AdditionalsAutoSidebarMenu.vue"
export default component.exports